import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
import _toConsumableArray from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray';
import _Set from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/set';

export var state = function state() {
  return {
    // users: [],
    authUser: null,
    authUserActorId: null,
    currentDateRaw: null,
    moduleSessionList: [],
    currentModuleSession: null,
    currentMsApplicantList: [],
    currentMsManagerList: [],
    currentPendingUploadFileUser: null,
    viewSearchModuleSession: null,
    viewSearchMsManager: null,
    viewDetailedList: null
  };
};

export var mutations = {
  setUser: function setUser(state, currentAuthUser) {
    state.authUser = currentAuthUser;
    state.authUserActorId = !!currentAuthUser ? currentAuthUser.id : null;
  },
  setDateRaw: function setDateRaw(state, currentDateRaw) {
    state.currentDateRaw = currentDateRaw;
  },
  setModuleSessionList: function setModuleSessionList(state, moduleSessionList) {
    state.moduleSessionList = moduleSessionList;
  },
  removeModuleSessionList: function removeModuleSessionList(state, moduleSession) {
    var msList = new _Set(state.moduleSessionList);
    msList.delete(moduleSession);
    state.moduleSessionList = [].concat(_toConsumableArray(msList));
  },
  setModuleSession: function setModuleSession(state, currentModuleSession) {
    state.currentModuleSession = currentModuleSession;
  },
  setcurrentMsApplicantList: function setcurrentMsApplicantList(state, currentMsApplicantList) {
    state.currentMsApplicantList = currentMsApplicantList;
  },
  setCurrentPendingUploadFileUser: function setCurrentPendingUploadFileUser(state, currentPendingUploadFileUser) {
    state.currentPendingUploadFileUser = currentPendingUploadFileUser;
  },
  addNewApplicantToApplicantList: function addNewApplicantToApplicantList(state, newApplicant) {
    state.currentMsApplicantList.push(newApplicant);
  },
  setcurrentMsManagerList: function setcurrentMsManagerList(state, currentMsManagerList) {
    state.currentMsManagerList = currentMsManagerList;
  },
  setViewSearchModuleSession: function setViewSearchModuleSession(state, viewSearchModuleSession) {
    state.viewSearchModuleSession = viewSearchModuleSession;
  },
  setViewSearchMsManager: function setViewSearchMsManager(state, viewSearchMsManager) {
    state.viewSearchMsManager = viewSearchMsManager;
  },
  setViewDetailedList: function setViewDetailedList(state, viewDetailedList) {
    state.viewDetailedList = viewDetailedList;
  }
};

export var actions = {
  nuxtServerInit: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit = _ref.commit;
      var req = _ref2.req,
          res = _ref2.res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (req.session && req.session.currentAuthUser) {
                console.log('\n\n this is req.session.currentAuthUser\n', req.session.currentAuthUser, '\n ===');
                commit('setUser', req.session.currentAuthUser);
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function nuxtServerInit(_x, _x2) {
      return _ref3.apply(this, arguments);
    }

    return nuxtServerInit;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = ./store/index.js
// module chunks = 20